import { Link, NavLink } from 'react-router-dom';
import iconReview from '../../assets/images/home.svg'
import icon2 from '../../assets/images/training.svg'
import icon3 from '../../assets/images/certifications.svg'
import icon4 from '../../assets/images/study.svg'
import icon5 from '../../assets/images/subscription.svg'
import { useState } from 'react';
const VerticalMenu = () => {
    const [menuOpen, setMenuOpen] = useState(false);

    const handleMenuToggle = () => {
        document.body.classList.toggle("show-mo-menu");
        setMenuOpen((prev) => !prev);
    };
    const handleMenuClose = () => {
        document.body.classList.remove("show-mo-menu");
        setMenuOpen(false);
    };
    return (
        <>
            <div id="vertical_menu" className="verticle-menu  collapsed-menu ">
                <div className="menu-list">


                    <NavLink
                        onClick={handleMenuClose}
                        to="/dashboard"
                        className={({ isActive }) => `menu-item ${isActive ? "active" : ""}`}
                    >
                        <img src={iconReview} alt="icon" className="menu-icon" />
                        Home
                    </NavLink>

                    <NavLink
                        onClick={handleMenuClose}
                        to="/exammanagement"
                        className={({ isActive }) => `menu-item ${isActive ? "active" : ""}`}
                    >
                        <img src={icon2} alt="icon" className="menu-icon" />
                        Exam Management
                    </NavLink>

                    <NavLink
                        onClick={handleMenuClose}
                        to="/payment"
                        className={({ isActive }) => `menu-item ${isActive ? "active" : ""}`}
                    >
                        <img src={icon3} alt="icon" className="menu-icon" />
                        Payment
                    </NavLink>

                    <NavLink
                        onClick={handleMenuClose}
                        to="/settings"
                        className={({ isActive }) => `menu-item ${isActive ? "active" : ""}`}
                    >
                        <img src={icon4} alt="icon" className="menu-icon" />
                        Settings
                    </NavLink>

                </div>
            </div>
        </>
    )
}
export default VerticalMenu;